export interface BestPracticeCheckDialogProps {
    documentId: string;
    documentVersionId?: string;
    onDialogClose: () => void;
    onCheckComplete: (result: BestPracticeCheckViewModel) => void;
}

export interface BestPracticeCheckCompareModel {
    documentId: string;
    documentVersionId?: string;
    bestPracticeDocumentTemplateId: string;
}

export enum BestPracticeCheckStatus {
    Pending = 1,
    Completed = 2,
    Failed = 3,
}

export enum BestPracticeCheckFindingType {
    MissingElement = 1,
    PartialCompliance = 2,
    FullCompliance = 3,
}

export interface BestPracticeCheckFindingViewModel {
    findingType: BestPracticeCheckFindingType;
    title: string;
    description: string;
    referenceQuote: string | undefined;
    documentQuote: string | undefined;
    recommendation: string | undefined;
}

export interface BestPracticeCheckDocumentVersionRow {
    documentVersionId: string;
    version: number;
    fileName: string | undefined;
    link: string | undefined;
    hasBestPracticeCheck: boolean;
    isTooLargeForAi: boolean;
}

export interface BestPracticeCheckViewModel {
    documentVersionId: string;
    id: string;
    status: BestPracticeCheckStatus;
    executiveSummary: string;
    created: string;
    checkedDocumentVersionId: string;
    checkedDocumentName: string | undefined;
    referenceDocumentId: string;
    referenceDocumentName: string | undefined;
    findings: Array<BestPracticeCheckFindingViewModel>;
}

export interface DocumentVersionBestPracticeResultOverviewViewModel {
    compliant: number;
    partialCompliant: number;
    missing: number;
}
